module.exports = __webpack_public_path__ + "img/blog-details.d3c3cc38.jpg";